import {getStyle} from '../input/InputHelper';

export interface RadioButtonCheckedHandler {
    (value: string | number): void
}

export type RadioButtonProps = {
    className?: string,
    name: string,
    value: string | number,
    label?: string,
    checked?: boolean,
    isValid?: boolean,
    onChecked?: RadioButtonCheckedHandler
}

const RadioButton = ({
                         className,
                         name,
                         value,
                         label,
                         checked,
                         onChecked,
                         isValid
                     }: RadioButtonProps) => {

    const onClick = () => {
        if (onChecked) {
            onChecked(value);
        }
    };

    const style = getStyle(false, false, false, '', !!isValid);

    return (
        <div className={`dfb-RadioButton${style} ${className ? className : ''}`}>
            <label className="dfb-RadioButton-field">
                <input className="dfb-RadioButton-input" type="radio" name={name} onClick={onClick} checked={checked} aria-checked={checked}/>
                <span className="dfb-RadioButton-box" aria-hidden="true"/>
                <span className="dfb-RadioButton-label">{label}</span>
            </label>
        </div>
    );
};

RadioButton.defaultProps = {
    className: '',
    label: '',
    checked: false,
    isValid: true
};

export default RadioButton;
